import { memo } from 'react';
import { clsx } from 'clsx';
import { FluidProgressIndicator } from '../ProgressIndicators';
import styles from './SpinnerPage.module.scss';

const SpinnerPage = memo(({ className }: { className?: string }) => {
    return (
        <div className={clsx(styles.container, className)}>
            <FluidProgressIndicator />
        </div>
    );
});

export default SpinnerPage;
